<template>
  <Catalogs
    title="Источники лидов"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'LeadSourceAdd'"
    :route-edit="'LeadSourceEdit'"
    :route-view="'LeadSourceView'"
    :route-path="'/lead_sources'"
    :can-edit="canEditLeadSourceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LeadSources",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getLeadSources(data);
    },
    canEditLeadSourceCatalogs() {
      return this.hasPermission([PERM.CATALOG_LEAD_SOURCE_EDIT]);
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LeadSources/LeadSources.vue